import { supabase } from "./supabase";

/**
 * この端末にパスキーを登録する。
 *
 * **サインイン済みでないと呼べない。** WebAuthn の登録は本人確認が済んだ後の
 * 操作で、Supabase も既存のセッションを要求する(→ ADR-0016)。
 */
export async function registerPasskey(): Promise<void> {
  const { error } = await supabase.auth.registerPasskey();
  if (error) throw error;
}

